module.exports = __webpack_public_path__ + "img/humedad_gray.c5b140e0.svg";